import { ref } from "vue";

export const isNavigating = ref(false);
